import React from 'react'

const SignOut = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 11.439 14.155"
      >
        <path
          d="M10.116 9.578h5.116m0 0-2.193 2.192m2.193-2.193-2.193-2.192m2.193-2.193v-.73A1.462 1.462 0 0 0 13.77 3H6.462A1.462 1.462 0 0 0 5 4.462v10.232a1.462 1.462 0 0 0 1.462 1.462h7.308a1.462 1.462 0 0 0 1.462-1.462v-.731"
          transform="translate(-4.5 -2.5)"
          style={{
            fill: 'none',
            stroke: '#b1b1b1',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      </svg>
    </div>
  )
}

export default SignOut
